import React from "react";
import { Link } from "@inertiajs/inertia-react";
import { Inertia } from "@inertiajs/inertia";
import CustomerLayout from "../../../Layouts/CustomerLayout";

const Show = ({ request, responses }) => {
  const isOpen = request.status === "open";

  function acceptResponse(responseId, tradesmanName) {
    if (
      !window.confirm(
        `Accept ${tradesmanName}? Other tradespeople will be told you went with someone else.`
      )
    )
      return;
    Inertia.post(`/domestic/requests/${request.id}/accept_response`, {
      response_id: responseId,
    });
  }

  return (
    <CustomerLayout title="Request Details">
      <div className="mt-6 max-w-3xl space-y-8">
        <Link
          href="/domestic/requests"
          className="text-sm font-medium text-orange-600 hover:text-orange-500"
        >
          &larr; Back to my requests
        </Link>

        <div className="rounded-md border border-gray-200 bg-white p-6">
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-medium text-gray-900">
              {request.trades.join(", ")}
            </h2>
            <span
              className={`inline-flex rounded-full px-2 text-xs font-semibold leading-5 ${
                isOpen
                  ? "bg-green-100 text-green-800"
                  : "bg-blue-100 text-blue-800"
              }`}
            >
              {request.status}
            </span>
          </div>
          <p className="mt-3 whitespace-pre-wrap text-sm text-gray-700">
            {request.description}
          </p>
          <dl className="mt-4 grid grid-cols-2 gap-4 text-sm">
            <div>
              <dt className="font-medium text-gray-500">Postcode district</dt>
              <dd className="text-gray-900">
                {request.postcode_district_code || "—"}
              </dd>
            </div>
            <div>
              <dt className="font-medium text-gray-500">Ideal start date</dt>
              <dd className="text-gray-900">
                {request.ideal_start_date || "—"}
              </dd>
            </div>
          </dl>
        </div>

        <div>
          <h3 className="text-lg font-medium text-gray-900">
            Responses from tradespeople
          </h3>
          {responses.length === 0 ? (
            <p className="mt-3 text-sm text-gray-500">
              No responses yet — local tradespeople matching your trades and
              area will see your request and get in touch here.
            </p>
          ) : (
            <ul className="mt-3 space-y-4">
              {responses.map((resp) => (
                <li
                  key={resp.id}
                  className={`rounded-md border p-4 ${
                    resp.status === "accepted"
                      ? "border-green-300 bg-green-50"
                      : resp.status === "declined"
                      ? "border-gray-200 bg-gray-50 opacity-70"
                      : "border-gray-200 bg-white"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-medium text-gray-900">
                      {resp.tradesman_name}
                      {resp.status === "accepted" && (
                        <span className="ml-2 inline-flex rounded-full bg-green-100 px-2 text-xs font-semibold leading-5 text-green-800">
                          accepted
                        </span>
                      )}
                      {resp.status === "declined" && (
                        <span className="ml-2 inline-flex rounded-full bg-gray-200 px-2 text-xs font-semibold leading-5 text-gray-600">
                          not chosen
                        </span>
                      )}
                    </p>
                    <p className="text-xs text-gray-400">{resp.created_at}</p>
                  </div>
                  <p className="mt-2 whitespace-pre-wrap text-sm text-gray-700">
                    {resp.message}
                  </p>
                  {resp.quote_amount && (
                    <p className="mt-2 text-sm font-semibold text-gray-900">
                      Quote: £{resp.quote_amount}
                    </p>
                  )}
                  {resp.status === "accepted" && resp.tradesman_contact && (
                    <div className="mt-3 rounded-md bg-white border border-green-200 p-3 text-sm">
                      <p className="font-medium text-gray-900">
                        Contact details
                      </p>
                      <p className="text-gray-700">
                        {resp.tradesman_contact.email}
                      </p>
                      {resp.tradesman_contact.phone && (
                        <p className="text-gray-700">
                          {resp.tradesman_contact.phone}
                        </p>
                      )}
                    </div>
                  )}
                  {isOpen && (
                    <button
                      type="button"
                      onClick={() =>
                        acceptResponse(resp.id, resp.tradesman_name)
                      }
                      className="mt-3 rounded-md bg-orange-600 py-1.5 px-4 text-sm font-medium text-white hover:bg-orange-700"
                    >
                      Accept this tradesperson
                    </button>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </CustomerLayout>
  );
};

export default Show;
